import React from 'react';
import Table from '../../common/components/table/agGrid/Table';
import { useOfficeBreakdownTable } from './hooks/useOfficeBreakdownTable';
import Loader from '@lwt-helix/loader';
import PropTypes from 'prop-types';

export const OfficeBreakdown = ({ gridRef }) => {
    const { tableProps, isLoading } = useOfficeBreakdownTable();
    if (isLoading) return <Loader />;
    return (<Table {...tableProps} gridRef={gridRef} />);
};

OfficeBreakdown.propTypes = {
    gridRef: PropTypes.object,
};
